import React, { useState, useEffect } from 'react';
import AddShippingModal from '../AddShippingModal';


const Shipping = ({addresses=[], handleShippingChange, setAddresses}) => {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <AddShippingModal addresses={addresses} open={open} setOpen={setOpen} setAddresses={setAddresses}/>
            <div className="flow-root mt-6">
                <ul className="-my-5 divide-y divide-gray-200">
                    {addresses.length !== 0 ? 
                        <>
                            {addresses.map((address, i) => (
                                <li key={i} className="py-5">
                                    <div className="relative">

                                        <h3 className="text-sm font-semibold text-gray-800">
                                            <input 
                                                id={`chosen-address`}
                                                name={`chosen-address`}
                                                onChange={handleShippingChange}
                                                value={JSON.stringify(address)}
                                                type='radio'
                                                className='focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 mr-2'
                                            />
                                            {/* Extend touch target to entire panel */}
                                            <label htmlFor={`chosen-address-${i}`}>
                                                {address.name}
                                                <br/>
                                                {address.street1}
                                            </label>
                                        </h3>
                                        <p className="mt-1 text-sm text-gray-600 line-clamp">
                                            {address.city}, {address.state} {address.zip}
                                        </p>
                                    </div>
                                </li>
                            ))}
                        </>
                        :
                        <p className='text-sm text-gray-600'> No addresses found </p>
                    }
                </ul>
            </div>
            <div className="mt-6 max-w-xs">
                <button
                    type='button'
                    className="w-full flex justify-center items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                    onClick={() => setOpen(true)}
                >
                    Change Shipping Address
                </button>
            </div>
        </div>
    );
};

export default Shipping;
